import { lastValueFrom } from 'rxjs';
import { EscolaService } from 'src/app/shared/services/escola.service';
import { UserLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { FuncionalidadesCivico } from '../enums/FuncionalidadesCivico';

export function obterCodigosEscolaVinculada(usuario: UserLoginSed | null | undefined): number[] {
  if (!usuario) {
    return [];
  }

  const codigosEscola = new Set<number>();
  const atribuicaoLogin = usuario.DadosUsuario?.[0];
  const codigoEscolaLogado = usuario.codigoEscola ?? atribuicaoLogin?.CodigoEscola ?? 0;

  if (codigoEscolaLogado > 0) {
    codigosEscola.add(codigoEscolaLogado);
  }

  (usuario.DadosUsuario ?? []).forEach((item) => {
    if (item.CodigoEscola > 0) {
      codigosEscola.add(item.CodigoEscola);
    }
  });

  return Array.from(codigosEscola);
}

export function obterCodigoEscolaPorDiretoria(
  usuario: UserLoginSed | null | undefined,
  codigoDiretoria?: number
): number {
  if (!usuario) {
    return 0;
  }

  if (usuario.codigoEscola && usuario.codigoEscola > 0) {
    return usuario.codigoEscola;
  }

  const atribuicoes = usuario.DadosUsuario ?? [];
  const atribuicoesFiltradas = codigoDiretoria
    ? atribuicoes.filter((item) => item.CodigoDiretoria === codigoDiretoria)
    : atribuicoes;

  const atribuicaoComEscola = atribuicoesFiltradas.find((item) => item.CodigoEscola > 0);
  return atribuicaoComEscola?.CodigoEscola ?? 0;
}

export function obterNomeEscolaPorDiretoria(
  usuario: UserLoginSed | null | undefined,
  codigoDiretoria?: number
): string | null {
  if (!usuario) {
    return null;
  }

  const atribuicoes = usuario.DadosUsuario ?? [];
  const atribuicoesFiltradas = codigoDiretoria
    ? atribuicoes.filter((item) => item.CodigoDiretoria === codigoDiretoria)
    : atribuicoes;

  const atribuicaoComNome = atribuicoesFiltradas.find((item) => !!item.NomeEscola?.trim());
  return atribuicaoComNome?.NomeEscola?.trim() ?? null;
}

export async function possuiEscolaCivicoMilitarVinculada(
  usuario: UserLoginSed | null | undefined,
  escolaService: EscolaService
): Promise<boolean> {
  const codigosEscola = obterCodigosEscolaVinculada(usuario);
  if (codigosEscola.length === 0) {
    return false;
  }

  try {
    const verificacoes = await Promise.all(
      codigosEscola.map(async (codigoEscola) => {
        const result = await lastValueFrom(escolaService.getVerificaEscolaCivicoMilitar(codigoEscola));
        return result.isSucess && result.data === true;
      })
    );

    return verificacoes.some((isCivicoMilitar) => isCivicoMilitar);
  } catch {
    return false;
  }
}

export async function podeVisualizarCivicoMilitar(
  usuario: UserLoginSed | null | undefined,
  escolaService: EscolaService,
  funcionalidadesPermitidas: FuncionalidadesCivico[] = [
    FuncionalidadesCivico.VisualizarDashboard,
    FuncionalidadesCivico.CadastrarFatoAluno,
    FuncionalidadesCivico.EditarFatoAluno,
    FuncionalidadesCivico.ExcluirFatoAluno,
  ]
): Promise<boolean> {
  const atribuicaoLogin = usuario?.DadosUsuario?.[0];
  const temFuncionalidade = usuario?.funcionalidades?.some((funcionalidade) =>
    funcionalidadesPermitidas.includes(funcionalidade)
  ) ?? false;

  if (!usuario || !temFuncionalidade) {
    return false;
  }

  if (atribuicaoLogin?.NumeroComportamento == 1 || atribuicaoLogin?.NumeroComportamento == 2) {
    return true;
  }

  if (atribuicaoLogin?.NumeroComportamento == 3 || atribuicaoLogin?.NumeroComportamento == 4) {
    return possuiEscolaCivicoMilitarVinculada(usuario, escolaService);
  }

  return false;
}
